import React from 'react';
import VideoSlide from '../../body/VideoSlide';

const WarningStatements = () => {
  return (
    <div className='text-left p-4 space-y-6'>
      <VideoSlide vidSrc={1194418643}></VideoSlide>;
    </div>
  );
};

export default WarningStatements;
